import Connector, { type ConnectorOptions } from './Connector';
import type WhiteboardController from '../controllers/WhiteboardController';
import { type IPoint } from 'fabric/fabric-impl';
import { ConnectorEnd } from '../types';

export type MindMapConnectorOptions = ConnectorOptions & {
  controller: WhiteboardController;
};

class MindMapConnector extends Connector {
  type = 'mindMapConnector';

  evented = false;
  selectable = false;
  collaborate = false;

  static create(points: IPoint[], options: MindMapConnectorOptions) {
    return options.controller.addToCanvas(
      new MindMapConnector(points, options)
    );
  }

  deleted() {
    this.removeLabels();
    this.attachments[ConnectorEnd.CONNECTOR_START]?.object?.detachConnector(
      this
    );
    this.attachments[ConnectorEnd.CONNECTOR_END]?.object?.detachConnector(this);
    this.canvas?.remove(this);
  }
}

export default MindMapConnector;
